import { useState } from 'react';
import { useActionLogsPageQueryParams } from './useActionLogsPageQueryParams';
import { parseDateFromURL } from '../utils/dateUtils';
import { DateRangeValue } from '../types/actionLogsTypes';

export const useActionLogsPageFilterState = () => {
  const { searchParams } = useActionLogsPageQueryParams();

  const urlRange = searchParams.get('range');
  const urlStart = searchParams.get('start');
  const urlEnd = searchParams.get('end');

  const isValidRange = urlRange && ['day', 'week', 'month', 'year', 'beginning'].includes(urlRange);

  const initialRange: DateRangeValue =
    urlRange === 'custom' || (urlStart && urlEnd)
      ? 'custom'
      : isValidRange
        ? (urlRange as DateRangeValue)
        : 'day';

  const [range, setRange] = useState<DateRangeValue>(initialRange);
  const [start, setStart] = useState<Date | null>(parseDateFromURL(urlStart));
  const [end, setEnd] = useState<Date | null>(parseDateFromURL(urlEnd));

  return { range, setRange, start, setStart, end, setEnd };
};
